<template>
  <div class="btn-appstore">
    <a
      href="https://itunes.apple.com/jp/app/pocket-curator/id1088763931?mt=8"
      target="_blank">
      <img :src="btnImageSrc">
    </a>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'BtnAppstore',
  components: {
    mapGetters
  },
  computed: {
    ...mapGetters(['lang']),
    btnImageSrc: function () {
      let imageSrc = ''
      if (this.lang.key === 'JP') {
        imageSrc = require('@/assets/img/btn-appstore-pc.png')
      } else {
        imageSrc = require('@/assets/img/btn-appstore-en.png')
      }
      return imageSrc
    }
  },
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  created () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  activated () {
  }
}
</script>
<style lang="postcss" scoped>
  @import '../../assets/css/mixins.css';
  @import '../../assets/css/variables.css';

  .btn-appstore {
    width: fit-content;
    margin: auto;
    &  img {
      height: 48px;
    }
  }
  @media (--breakPoint) {
    .btn-appstore {
      & img {
        height: 36px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/atoms/BtnAppstore.vue